import React from 'react';
import { Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';
export const Footer: React.FC = () => {
  return <footer className="bg-brand-emerald text-white py-6" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-5" data-id="element-45">
        {/* Top row: logo on the left; tagline + legal links stacked and centered */}
        <div className="flex flex-col md:flex-row md:items-center gap-5" data-id="element-46">
          {/* Logo left */}
          <div className="flex justify-center md:justify-start shrink-0" data-id="element-47">
            <BrandLogo widthPx={260} variant="white" data-id="element-48" />
          </div>

          {/* Centered tagline + legal links below */}
          <div className="flex-1 flex flex-col items-center gap-3 text-center" data-id="element-49">
            <p className="text-xs sm:text-sm italic text-brand-mint whitespace-nowrap" data-id="element-50">
              Tu cuerpo tiene un código. Aquí te ayudamos a descifrarlo.
            </p>

            <div className="flex flex-wrap justify-center items-center gap-3 sm:gap-5 text-sm font-medium text-white" data-id="element-51">
              <Link to="/privacidad" className="hover:underline underline-offset-4 transition-all" data-id="element-52">
                Política de Privacidad
              </Link>
              <span className="text-white/30" data-id="element-53">|</span>
              <Link to="/terminos" className="hover:underline underline-offset-4 transition-all" data-id="element-54">
                Términos y Condiciones
              </Link>
              <span className="text-white/30" data-id="element-55">|</span>
              <a href="https://www.facebook.com/profile.php?id=61589346766845" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sky-300 hover:opacity-80 transition-opacity" data-id="element-56">
                <Facebook className="w-5 h-5 text-sky-300" data-id="element-57" />
                <span data-id="element-58">@elcodigodelbienestar</span>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="w-full pt-4 border-t border-white/15 text-center text-xs sm:text-sm text-brand-mint" data-id="element-59">
          <p data-id="element-60">© 2026 El Código del Bienestar. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
};